export default function setScrollbarWidth(
  cssVariableName = '--scrollbar-width'
) {
  document.documentElement.style.setProperty(
    cssVariableName,
    `${window.innerWidth - document.documentElement.clientWidth}px`
  )
}
